export const MatchedMapEventName: {[key: string]: string} = {
  onAddLayer: 'addLayer',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onDblclick: 'dblclick',
  onDoubletap: 'doubletap',
  onDrag: 'drag',
  onDragend: 'dragend',
  onDragstart: 'dragstart',
  onIdle: 'idle',
  onKeydown: 'keydown',
  onKeyup: 'keyup',
  onLongtap: 'longtap',
  onMousedown: 'mousedown',
  onMousemove: 'mousemove',
  onMouseout: 'mouseout',
  onMouseover: 'mouseover',
  onMouseup: 'mouseup',
  onPanning: 'panning',
  onPinch: 'pinch',
  onPinchend: 'pinchend',
  onPinchstart: 'pinchstart',
  onRemoveLayer: 'removeLayer',
  onResize: 'resize',
  onRightclick: 'rightclick',
  onTap: 'tap',
  onTilesloaded: 'tilesloaded',
  onTouchend: 'touchend',
  onTouchmove: 'touchmove',
  onTouchstart: 'touchstart',
  onTwofingertap: 'twofingertap',
  onZooming: 'zooming',
  onMapTypeChanged: 'mapType_changed',
  onMapTypeIdChanged: 'mapTypeId_changed',
  onSizeChanged: 'size_changed',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onCenterPointChanged: 'centerPoint_changed',
  onProjectionChanged: 'projection_changed',
  onZoomChanged: 'zoom_changed',
};
